import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, onUnmounted, onUpdated, Ref, ref, nextTick, watch } from "vue"
import { usePiniaState } from "@/store/userPinia";
import { useRouter, useRoute } from "vue-router";
import indexDB from "@/network/db/dexieDb";
import EventBus from "@/uitls/EventBus";
import { ChatUtils } from "@/uitls/ChatUtils";
import { Toast } from "vant";
import { useI18n } from 'vue-i18n'
import { isNumber } from "@/uitls/is";
import Clipboard from "clipboard";
import { checkSetNickname, toDownloadApp } from "@/uitls/native";
import { storeToRefs } from "pinia";
import IMUtils from "@/network/socket/imUtils";
import { uploadurl } from "@/api/im/index";
import { encryptionGetQAList } from "@/api/php/player";
import { ImagePreview } from 'vant';
import Storage from "@/uitls/Storage"
import Platform from "@/config/platform";
import TextEllipsis from "@/components/TextEllipsis.vue";

import { imMessageListModel, imChatModel, imUserModel, imGroupListModel } from "@/model/chatModel"
import { IMformatDate, md5, YMPush, msgdataimg, filedatasize } from "@/uitls/uitls"
import {
    msg_send_private_msg,
    msg_send_group_msg,
    msg_get_user_info,
    msg_confirm_hasread_msg,
    msg_get_hasread_list,
    msg_confirm_read_msg,
    msg_need_read_group_notify,
    msg_read_group_notify
} from "@/network/socket/SocketReq"

import {
    createIMList,
    getIMChatAll,
    getIMListItem,
    getImUser,
    updateIMList,
    createChat,
    getChatLast,
    getImGroupItem
} from "@/network/db/dbServe";

import checked_sel from "@/assets/images/checked_sel.png";
import checked from "@/assets/images/checked.png";
import biaoqing from "@/assets/images/biaoqing.png";
import add_res from "@/assets/images/icon_friend_add.png";
import sendBtn from "@/assets/images/sendBtn.png";
import faqClose from "@/assets/images/FAQ_close.png";
import faqBack from "@/assets/images/FAQ_back.png";
interface ChatProps {
    id?: string;
    autoMsg?: string,
    faqAssistanceUid?: string | number,
}
interface ChatFaqItem {
    title: string;
    shortTitle?: string;
    answer?: string | string[];
    content?: string | string[];
    detail?: string | string[];
    desc?: string | string[];
    images?: string[];
    image?: string;
    img?: string;
    pic?: string;
    url?: string;
}


export default /*#__PURE__*/_defineComponent({
  name: 'Chat',
  props: {
    id: { type: String, required: false, default: "" },
    autoMsg: { type: String, required: false, default: "" },
    faqAssistanceUid: { type: [String, Number], required: false, default: "" }
  },
  emits: ['privateGoback'],
  setup(__props: any, { expose, emit: emits }) {
  expose();

const props = __props as { id: string, autoMsg: string, faqAssistanceUid: string | number }


const zbimg = require(`@/assets/${process.env.VUE_APP_NAME}/zbtype.png`)
const adminimg = require(`@/assets/${process.env.VUE_APP_NAME}/admintype.png`)
const copy_id = require(`@/assets/${process.env.VUE_APP_NAME}/copy_id.gif`)

const { t } = useI18n()
const th = process.env.VUE_APP_Language as string;
const bqSwpierList = ChatUtils.renderBq();
const router = useRouter();
const route = useRoute();
const userStore = usePiniaState();
const { user } = storeToRefs(userStore);
const { toLogin } = userStore;
const name = ref("");
const list: Ref<Array<imChatModel>> = ref([])
const { id } = route.query;
let chatkey: any = id as string;
//是否群组
const isGroup = ref(false);
const groupMemberCount = ref('');

const showAddRes = ref(false);
//输入的文字
const inputValue = ref("");
const fileList = ref([]);
const showShare = ref(false);
const arterBg = require(`@/assets/${process.env.VUE_APP_NAME}/download.png`)
const arterBtn = require(`@/assets/${process.env.VUE_APP_NAME}/download_btn.png`)
const offArterBtn = require("@/assets/images/guanbi.png")

//滚动条实时的高度
var nowScrollHeight = 0;

//下拉获取更多消息
const page = ref(1)
const loading = ref(false);
//没有更多数据了
const noMoreData = ref(false)
const isforbidchat = ref(false);
const forbidtime = ref('');
const showNotice = ref(false);
const showNoticeGroup: any = ref({});
const adminUidList = ref([])
const whiteUidList = ref([])
let chatmsgno_list = [];

const onRefresh = () => {
    page.value++;
    getMsgList();
};

const clientHeight = ref(0)
const refrenceCon: any = ref({});
const hasInit = ref(false);
const standalone = Platform.standalone;
const normalizeUid = (uid: unknown) => uid == null ? "" : String(uid);
const getCurrentUid = () => normalizeUid(user.value.uid || Storage.get("uid"));
const isSelfMessage = (item: Pick<imChatModel, "uid">) => normalizeUid(item.uid) === getCurrentUid();
const autoAssistanceClientKeyPrefix = "auto_assistance_sent:";
const getChatTargetUid = () => {
    if (!chatkey || IMUtils.isGroup(chatkey)) {
        return "";
    }
    return normalizeUid(IMUtils.decodeChatkey(chatkey));
};



const showFaqPanel = ref(false);
const faqView = ref("list");
const activeFaq = ref<ChatFaqItem | null>(null);
const remoteFaqList = ref<ChatFaqItem[]>([]);
const faqQuickScrollRef = ref<HTMLElement | null>(null);

const normalizeAiReplyItem = (raw: any) => {
    if (!raw || typeof raw !== "object" || !raw.question) {
        return null;
    }
    return {
        title: String(raw.question),
        answer: raw.answer || "",
    } as ChatFaqItem;
};

const loadFaqList = async () => {
    const assistanceUid = normalizeUid(props.faqAssistanceUid || getChatTargetUid());
    if (!assistanceUid) {
        remoteFaqList.value = [];
        return;
    }
    try {
        const res = await encryptionGetQAList({
            assistance_uid: assistanceUid,
        });
        const list = res && res.data && Array.isArray(res.data.qa_library) ? res.data.qa_library : [];
        remoteFaqList.value = list.map(normalizeAiReplyItem).filter(Boolean) as ChatFaqItem[];
    } catch (e) {
        remoteFaqList.value = [];
    }
};

const faqItems = computed(() => {
    return remoteFaqList.value;
});

const hasFaq = computed(() => !isGroup.value && faqItems.value.length > 0);

const msgListBottomSpace = computed(() => {
    const baseSpace = props.id ? (standalone ? 130 : 110) : (standalone ? 100 : 70);
    return `${baseSpace + (hasFaq.value ? 42 : 0)}px`;
});

const faqQuickItems = computed(() => faqItems.value);

const getFaqHtml = (item: ChatFaqItem | null) => {
    if (!item) {
        return "";
    }
    const raw = item.content || item.answer || item.detail || item.desc || "";
    if (Array.isArray(raw)) {
        return raw.map((text) => String(text)).join("\n");
    }
    return String(raw);
};

const openFaqList = () => {
    faqView.value = "list";
    activeFaq.value = null;
    showFaqPanel.value = true;
};

const openFaqDetail = (item: ChatFaqItem) => {
    activeFaq.value = item;
    faqView.value = "detail";
    showFaqPanel.value = true;
};

const closeFaqPanel = () => {
    showFaqPanel.value = false;
};


const onDbread = () =>{
    getChatInfo()
    getMsgList();
}


onMounted(() => {
    if (hasInit.value) {
        return;
    }
    hasInit.value = true;
    initChatkey();
    EventBus.autoOn("dbOnsuccess", onDbread);
});

watch(() => props.autoMsg, (newVal, oldVal) => {
    if (newVal && newVal !== oldVal && hasInit.value) {
        getMsgList(true);
    }
});

watch(() => props.faqAssistanceUid, () => {
    if (hasInit.value) {
        loadFaqList();
    }
});

watch(remoteFaqList, () => {
    nextTick(() => {
        if (faqQuickScrollRef.value) {
            faqQuickScrollRef.value.scrollLeft = 0;
        }
    });
});


const initChatkey = async () => {
    inputValue.value = '';
    list.value = [];
    name.value = '';
    if (props.id && props.id != '') {
        chatkey = props.id;
    } else {
        const { id } = route.query;
        if (id && id != '') {
            chatkey = id as string;
        }
    }
    toLogin();
    getChatInfo();
    getMsgList(true);
    goUpdateIMList();

    YMPush('MAIN', 'PrivateLetter');

    window.removeEventListener('scroll', scrollHandle)
    window.addEventListener('scroll', scrollHandle);//绑定页面滚动事件

    if (IMUtils.isGroup(chatkey)) {
        isGroup.value = true;
    } else {
        isGroup.value = false;
    }
    loadFaqList();
    EventBus.on("imchat", (resChatkey?) => {
        if (resChatkey == chatkey) {
            getMsgList(true);
        }
        isNewMsg.value = true;
    });

    EventBus.on('updateGroup', (msg: any) => {
        if (msg.chatkey === chatkey) {
            lookGroup();
        }
    })

    if (isGroup.value) {
        msg_need_read_group_notify(chatkey);
    }
}

onUnmounted(() => {
    EventBus.off("imchatUser");
    EventBus.off("dbOnsuccess");
    EventBus.off("imchatRad");
    EventBus.off("imchat");
    EventBus.off('updateGroup');
    EventBus.off('event_show_notice');
    window.removeEventListener('scroll', scrollHandle)
});

EventBus.on('event_show_notice', async (show: boolean) => {
    console.log('event_show_notice', show);
    if (show) {
        let group = await getImGroupItem(chatkey);
        if (group && group.groupnotify.length > 0) {
            showNotice.value = true;
            showNoticeGroup.value = group
        }
    }
});

//更新已读数量
EventBus.on("imchatRad", async (msg: any) => {
    if (msg.chatkey.toString() == chatkey && msg.chatmsgno_list && msg.chatmsgno_list.length > 0) {
        const readMsgNoSet = new Set(msg.chatmsgno_list);
        list.value.forEach((item) => {
            if (readMsgNoSet.has(item.chatmsgno)) {
                item.read = true;
            }
        });
    }
    const imItem: imMessageListModel = await getIMListItem(msg.chatkey.toString())
    if (imItem && imItem.red > 0 && msg.chatkey.toString() == chatkey) {
        imItem.red = 0;
        updateIMList(msg.chatkey.toString(), imItem);
    }
});

EventBus.on("imchatUser", (evt: any) => {
    console.log('imchatUser', evt, evt.is_new);
    if (evt.is_new) {
        getChatInfo();
    }
});
EventBus.on("dbOnsuccess", () => {
    getChatInfo()
    getMsgList();
});

const goUpdateIMList = async () => {
    if (!indexDB.open) {
        return;
    }
    if (props.id) {
        return;
    }
    const imItem: imMessageListModel = await getIMListItem(chatkey);
    if (!!imItem && imItem.red > 0) {
        imItem.red = 0;
        await updateIMList(chatkey, imItem);
    }
}

//如果是新消息来了，滚动条有一个滚动的效果
const isNewMsg = ref(false)
//页面刷新，滚动到最底部
onUpdated(() => {
    //Toscroll();
});

const Toscroll = () => {
    if (scrollDisabled.value) {
        if (page.value == 1) {
            const height = document.body.clientHeight;
            window.scroll({ top: height, left: 0, behavior: isNewMsg.value ? "smooth" : "auto" });
        } else {
            const height = document.body.clientHeight;
            window.scroll({ top: height - clientHeight.value, left: 0, behavior: "auto" });
        }
    }
    isNewMsg.value = false
}
// imchat
const onClickLeft = () => {
    router.back();
}

const scrollHandle = (e) => {
    nowScrollHeight = e.srcElement.scrollingElement.scrollHeight  //滚动条的高度
    let halfH = nowScrollHeight - document.documentElement.clientHeight * 1.8
    const top = e.srcElement.scrollingElement.scrollTop;    // 获取页面滚动高度
    // console.log('top <100',top ==0);
    if (top == 0 && !loading.value && !noMoreData.value) {
        onRefresh()
    }
    if (top < halfH && scrollDisabled.value) {
        scrollDisabled.value = false;
    }
}

//去除重复数组
const unique = (arr: Array<imChatModel>) => {
    const res = new Map();
    return arr.filter((item) => {
        const clientkey = item.clientkey ? String(item.clientkey) : "";
        const key = isAutoAssistanceMessage(item) && clientkey ? `${item.chatkey}-clientkey-${clientkey}` : `${item.chatkey}-${item.chatmsgno}`;
        return !res.has(key) && res.set(key, 1);
    })
}

const isAutoAssistanceMessage = (item: Partial<imChatModel>) => {
    const clientkey = item.clientkey ? String(item.clientkey) : "";
    const id = item.id ? String(item.id) : "";
    return clientkey.startsWith(autoAssistanceClientKeyPrefix) || id.startsWith(autoAssistanceClientKeyPrefix);
};

const getAutoMsgList = () => {
    if (!props.autoMsg) {
        return [];
    }
    try {
        const result = JSON.parse(props.autoMsg);
        return Array.isArray(result) ? result : [];
    } catch (e) {
        console.log("autoMsg parse fail", e);
    }
    return [];
};

//获取每个信息
const getMsgList = async (clearList = false) => {
    if (!indexDB.open) {
        return;
    }
    clientHeight.value = document.body.clientHeight;
    loading.value = true

    let datalist: Array<imChatModel> = []
    if (clearList) {
        page.value = 1;
        noMoreData.value = false;
    } else {
        datalist = list.value;
    }
    let imList: Array<imChatModel> = await getIMChatAll(chatkey, page.value);
    console.log(imList);
    const autoMsgList: Array<imChatModel> = getAutoMsgList();
    if (autoMsgList.length) {
        datalist = datalist.filter((item) => !isAutoAssistanceMessage(item));
        imList = imList.filter((item) => !isAutoAssistanceMessage(item));
        if (page.value == 1) {
            imList = autoMsgList.concat(...imList);
        } else {
            datalist = autoMsgList.concat(...datalist);
        }
    }
    if (imList.length != 20) {
        noMoreData.value = true;
    }
    chatmsgno_list = []
    const selfChatmsgnoList = []
    if (imList.length > 0 || datalist.length > 0) {
        imList = unique(imList)
        for (let i = 0; i < imList.length; i++) {
            const element = imList[i];
            if (!!!element.id) {
                element.id = element.chatmsgno;
            }
            if (!!!element.msgtype) {
                element.msgtype = 1;
            }
            if (!element.read && !isSelfMessage(element)) {
                chatmsgno_list.push(element.chatmsgno)
            }
            if (!element.read && isSelfMessage(element) && element.chatmsgno) {
                selfChatmsgnoList.push(element.chatmsgno)
            }
        }
        list.value = unique([...imList, ...datalist]);
        // 排序
        list.value.sort((a, b) => {
            if (a.chatmsgno && b.chatmsgno) {
                return (a.chatmsgno - b.chatmsgno) || (a.time - b.time) || ((a.id || 0) - (b.id || 0));
            } else {
                return a.time - b.time;
            }
        });
    }

    loading.value = false;


    if (chatmsgno_list.length > 0) {
        //确认消息已读
        msg_confirm_hasread_msg(chatkey, [...new Set(chatmsgno_list)])
    }
    if (selfChatmsgnoList.length > 0) {
        msg_get_hasread_list(chatkey, [...new Set(selfChatmsgnoList)])
    }
    nextTick(() => {
        scrollToBottom();
    });
}
const headurl = ref('')
const groupBgc = ref('')

//生成群头像
const createAvarar = (name) => {
    //生成群头像
    let nickname: string = name
    nickname = nickname.substring(0, 4) || t("im.groups")
    const regex = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;
    const emjio = regex.exec(nickname)
    if (emjio) {
        //如果有emjio
        headurl.value = emjio[0]
    } else {
        headurl.value = nickname[0]
    }
    //生成颜色
    let bgcolor = "#" + md5(nickname[0])
    bgcolor = bgcolor.substring(0, 7)
    groupBgc.value = bgcolor

}
//获取这个会话的信息
const getChatInfo = async () => {
    if (!indexDB.open) {
        return;
    }
    // if (props.id) {
    //     return;
    // }
    console.log("getChatInfo", chatkey);
    isGroup.value = IMUtils.isGroup(chatkey);
    //解析chatkey
    const chatkey2 = IMUtils.decodeChatkey(chatkey);
    const imItem: imMessageListModel = await getIMListItem(chatkey);
    if (imItem) {
        //在会话列表，有数据的
        name.value = imItem.nickname
        if (imItem.isGroup) {
            createAvarar(imItem.nickname)
        } else {
            headurl.value = imItem.headurl;
        }
    } else {
        //在其他地方私聊进来的。要处理
        let u: imUserModel = await getImUser(chatkey2);

        if (u) {
            name.value = u.nickname
            headurl.value = u.headurl;
        } else {
            //去查这个人的信息
            msg_get_user_info(chatkey2)
        }
    }
    lookGroup();
}




const preSqldata = async (data, msgtype) => {
    const res = await getChatLast(chatkey);
    // console.log('预存数据',data);
    let chat = {} as imChatModel;
    chat.content = data;
    chat.uid = user.value.uid;
    chat.time = Math.floor(new Date().getTime() / 1000);
    chat.headurl = user.value.avatar;
    chat.nickname = user.value.nickName;
    chat.clientkey = "";
    chat.chatkey = chatkey;
    chat.msgtype = msgtype;
    chat.chatmsgno = res ? res.chatmsgno + 1 : 1;
    chat.read = false;
    const msgdatasend = await createChat(chat); // 存进去的数据
    return msgdatasend; // 数据库id
};

// 上传文件进度
const upaddataall = async (chatkeys, formdata, url, sqlid, type, strData?) => {
    let chatkeyss = chatkeys;
    let upLoadProgress = 0; // 上传进度
    return new Promise((resolve, reject) => {
        axios({
            url: url,
            method: "post",
            headers: {
                "Content-Type": "multipart/form-data",
            },
            data: formdata,
            onUploadProgress: function (progressEvent) {
                //原生获取上传进度的事件
                if (progressEvent.lengthComputable) {
                    upLoadProgress = ((progressEvent.loaded / progressEvent.total) * 100) | 0; //实时获取上传进度
                    for (let i in list.value) {
                        if (list.value[i].id == sqlid) {
                            list.value[i].upLoadProgress = upLoadProgress;
                        }
                    }
                }
            },
        }).then((res) => {
            if (res.data.ret == 0 && res.data.fileurl) {
                resolve(res.data.fileurl)
            } else {
                Toast.fail(t('tips.uploadFail'));

            }
        }).catch((err) => {
            Toast.fail(t('tips.uploadFail'));
        });
    })
};
const addImg = async (file: any) => {
    addRes(file, 4)
}
const addVideo = async (file: any) => {
    addRes(file, 3)
}
const addFile = async (file: any) => {
    addRes(file, 15)
}

const addRes = async (file?: any, type?: any) => {
    showAddRes.value = false;
    if (!!!file) return;
    file.status = 'uploading';
    file.message = t('me.scz');

    //处理数据
    let resFile = file.file;
    let formData = new FormData();
    formData.append("pic", resFile);
    formData.append("uid", String(user.value.uid))
    formData.append("is_head", '0');


    // //获取最后一个.的位置
    // let index = resFile.name.lastIndexOf(".");
    // //获取后缀
    // let ext = resFile.name.substr(index + 1);
    type = type || 15;
    let data = null;
    data = {
        url: file.content,
        size: resFile.size,
        filename: resFile.name,
    }

    // 预存数据库
    const sqlid = await preSqldata(JSON.stringify(data), type);
    // 更新界面的数据
    await getMsgList(true);


    //进度条
    const url = await uploadurl(formData);
    const fileurl = await upaddataall(chatkey, formData, url, sqlid, type);


    data.url = fileurl;
    let strData = JSON.stringify(data);

    // 发送消息
    sendMsg(type, strData)
}


const onOversize = async () => {
    Toast.fail('onOversize');
}

const sendMsg = async (type?, data?) => {
    if (!checkSetNickname(user.value.fname, user.value.phone)) {
        return false;
    }
    type = isNumber(type) ? type : 1;
    let sendData = null;
    switch (type) {
        case 1:
            sendData = inputValue.value.trim();
            if (inputValue.value == "") return Toast.fail(t('me.tpisnodata'));
            // sendData = JSON.stringify(inputValue.value.trim());
            if (getmsgurl(sendData)) type = 6;
            // console.log('refrenceCon.value',refrenceCon.value);
            if (showRefrence.value == true && refrenceCon.value.content) {
                type = 21;
                sendData = JSON.stringify({
                    content: sendData,
                    reference: tryParse(refrenceCon.value)
                })
                // sendData=JSON.stringify(sendData)
                showRefrence.value = false;
            }

            // // 预存数据库
            // await preSqldata(sendData, type);
            // // 更新界面的数据
            // await getMsgList(true);
            break;
        case 4:
            sendData = data;
            break;
        case 3:
            sendData = data;
            break;
        default:
            sendData = data;
    }
    const chatkey2 = IMUtils.decodeChatkey(chatkey)
    if (IMUtils.isGroup(chatkey)) {
        //发送群消息
        isGroup.value = true;
        msg_send_group_msg(chatkey2, sendData, type)
        // console.log('sendData发送群消息1',sendData);
    } else {
        msg_send_private_msg(chatkey2, sendData, type);
        // console.log('发送私聊消息',sendData);
        //如果这个会话还没创建， 去创建一个
        //私聊
        const val: imMessageListModel = await getIMListItem(chatkey)
        let tempUser: imUserModel = await getImUser(chatkey2);
        const meAnchor = Storage.get('meAnchor');
        if (!val) {
            //去新建
            let m = {} as imMessageListModel;
            m.headurl = tempUser ? tempUser.headurl : name.value
            m.content = sendData;
            m.uid = chatkey2;
            m.msgtype = type;
            m.chatkey = chatkey;
            m.time = new Date().getTime()
            m.nickname = tempUser ? tempUser.nickname : headurl.value;
            m.red = 0;
            m.isGroup = false;
            createIMList(m);
            if (meAnchor) {
                console.log('我是主播');
                window.$apiNet.statisticsPost({ anchor_id: meAnchor, room_key: chatkey, action_id: '17' });//主播私信用户 统计打点
            }
        }
        if (meAnchor) {
            console.log('我是主播');
            window.$apiNet.statisticsPost({ anchor_id: meAnchor, room_key: chatkey, action_id: '16' });//主播回复 统计打点
        } else {
            window.$apiNet.statisticsPost({ anchor_id: '', room_key: chatkey, action_id: '14' });// 统计打点
        }

    }
    const imItem: imMessageListModel = await getIMListItem(chatkey)
    if (imItem) {
        //在会话列表，有数据的
        imItem.content = sendData;
        imItem.msgtype = type;
        imItem.time = new Date().getTime();
        updateIMList(chatkey, imItem)
    }
    inputValue.value = "";
    showShare.value = false;
    scrollDisabled.value = true;
};

// 发送消息前处理是否链接
const getmsgurl = (txt) => {
    const reg =
        /(((https?:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/gi;
    const result = txt.match(reg);
    if (result && txt.indexOf("/script>") == -1) {
        return true;
    } else {
        return false;
    }
};


const openBiaoqing = () => {
    showShare.value = !showShare.value;
};

//选中了表情
const selBq = (name: string) => {
    inputValue.value = inputValue.value + name;
};

const getJsonImage = (content: any) => {
    try {
        const obj = JSON.parse(content)
        return obj.url
    } catch (e) {
        // console.log('e',e,content.url);
        return content.url
    }
}
const getJsonImageWid = (content: any) => {
    try {
        const obj = JSON.parse(content);
        if (obj.width && obj.width > 0) {
            return Math.min(obj.width / 2, 250);
        }
    } catch (e) { }
    return 200;
}

const onImagePreview = (img: string) => {
    ImagePreview([img]);
}

//滚动条可以滑动
const scrollDisabled = ref(true)

//防抖
var timeout;
const debounce = (func, wait = 500, immediate = false) => {
    if (inputValue.value !== "") {
        //设置状态，不再滚动
        // console.log("不能滚动了");

        scrollDisabled.value = false
    }
    // 清除定时器
    if (timeout !== null) clearTimeout(timeout);
    // 立即执行，此类情况一般用不到
    if (immediate) {
        var callNow = !timeout;
        timeout = setTimeout(function () {
            timeout = null;
        }, wait);
        if (callNow) typeof func === 'function' && func();
    } else {
        // 设置定时器，当最后一次操作后，timeout不会再被清除，所以在延时wait毫秒后执行func回调方法
        timeout = setTimeout(function () {
            typeof func === 'function' && func();
        }, wait);
    }
}

const changeInputType = () => {
    //设置状态，可以滚动
    scrollDisabled.value = true;
}

const downloadshow = ref(false);
const showDownApp = (img) => {
    console.log(th);
    if (th == 'th') {
        ImagePreview([img]);
        return;
    }

    let { webclip } = route.query;
    if (!webclip) {
        downloadshow.value = true;
    } else {
        ImagePreview([img]);
    }
};

const open = () => {
    if (Platform.downUrl != "") {
        YMPush("DOWNLOAD", "点击下载")
        toDownloadApp();
    }
};



const checkname = (isGroup, name) => {
    if (isGroup && name == "") {
        return t('im.group')
    } else {
        return name;
    }
}
const keyup_submit = (e) => {
    var evt = window.event || e;
    if (evt.keyCode == 13) {
        //回车事件
        sendMsg(1)
    }
}

// @高亮
const atemsg = (data) => {
    if (typeof data == "string") {
        data = JSON.parse(data)
        if (typeof data.content == "string") {
            data.content = JSON.parse(data.content)
        }
    } else {
        if (typeof data.content == "string") {
            try {
                data.content = JSON.parse(data.content)
            } catch (e) {
                console.log('e', data.content);
            }
        }
    }
    if (data && data.content && data.content.uids && data.content.uids) {
        let hasid = false;
        // let userLs=[];
        for (let i in data.content.uids) {
            if (data.content.uids[i] == user.value.uid) {
                hasid = true;
            }
        }
        if (hasid) {
            const firstname = user.value.firstname;
            const lastname = user.value.lastname;
            let nickName = user.value.nickName;
            if (firstname && firstname != "" && lastname && lastname != "") {
                nickName = firstname + " " + lastname;
            } else if (firstname && firstname != "") {
                nickName = firstname;
            } else if (lastname && lastname != "") {
                nickName = lastname;
            }
            let str = data.content.content;
            str = str
                .split("@" + nickName)
                .join("<span style='color:#4F4FEC;'>" + "@" + nickName + "</span>");
            if (str && str != "" && str != null && str != undefined) {
                return msgurl(str);
            } else {
                return msgurl(data.content.content);
            }
        } else {
            return msgurl(data.content.content);

        }

    }
};

// 处理链接消息
const msgurl = (txt) => {
    const reg =
        /(((https?:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/gi;
    const result = txt.replace(reg, function (item) {
        if (item.search("http") < 0 && item.search("HTTP") < 0) {
            return (
                '<a href="' + "http://" + item + '" target="_blank">' + item + "</a>"
            );
        } else {
            return "<a href='" + item + "' target='_blank'>" + item + "</a>";
        }
    });
    return result;
};

// 图片路径拼接
const dataimgurl = (val) => {
    if (typeof val.content == 'string') {
        try {
            val.content = JSON.parse(val.content)
        } catch (e) {
            val.content = val.content;
        }
    }
    if (val) {
        let name = msgdataimg(val);
        if (name != "" && name != null && name != undefined) {
            let imgname = require("@/assets/images/wenjian-" + name + ".png");
            return imgname;
        } else {
            return "";
        }
    } else {
        return "";
    }
};
// 点击下载
const tapFile = (url, filename, d) => {
    fetch(url)
        .then((res) => {
            res.blob().then((blob) => {
                const blobUrl = window.URL.createObjectURL(blob);
                // 这里的文件名根据实际情况从响应头或者url里获取
                const a = document.createElement("a");
                a.style.display = "none";
                a.href = blobUrl;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(blobUrl);
                msg_confirm_read_msg(d.chatkey, d.chatmsgno)
            });
        })
        .catch((error) => {
            console.log("文件下载失败", error);
        });

};

// 播放语音
const audioclick = (id) => {
    const audio: any = document.getElementById("audio" + id); // 获取元素
    const aduiodimg = document.getElementById("audioimg" + id);
    if (audio) {
        if (audio.paused) {
            audio.play();
            if (aduiodimg) {
                aduiodimg.classList.add("audioplayimg");
            }
        } else {
            audio.pause();
            if (aduiodimg) {
                aduiodimg.classList.remove("audioplayimg");
            }
        }
    } else {
        Toast({
            message: "语音出错",
            position: "bottom",
        });
    }
};
// 播放结束
const ended = (id) => {
    // console.log("播放结束");
    const aduiodimg = document.getElementById("audioimg" + id);
    if (aduiodimg) {
        aduiodimg.classList.remove("audioplayimg");
    }
};

const tryParse = (data) => {
    try {
        return JSON.parse(data)
    } catch (e) {
        // console.log('e',data);
        return data
    }
}
const refplay = (id) => {
    let Media: any = document.getElementById("videoPlayer1" + id);
    Media.play();
    Media.webkitRequestFullScreen()
}
const options = ref({
    show: false,
    top: 0,
    left: 0,
    items: ['引用']
})

const showMenu = (item, top, left) => {
    // console.log('item',item);
    if (!!!item.content) return hideMenu();
    options.value.show = true;
    refrenceCon.value = item;
    options.value.top = top;
    options.value.left = left;
}

const optionTap = (item) => {
    options.value.show = false;
    if (item == '引用') {
        toRefrence()
    }
}
let showRefrence = ref(false)
const toRefrence = () => {
    showRefrence.value = true;
}

const hideMenu = () => {
    showRefrence.value = false;
    options.value.show = false;
    refrenceCon.value = {};
}


const copyclass = (eleClass, data) => {
    if (data != "" && data != null && data != undefined) {
        let clipboard = new Clipboard("." + eleClass, {
            text: () => {
                return data;
            },
        });
        clipboard.on("success", (e) => {
            // 释放内存
            clipboard.destroy();
            Toast({
                message: t('tips.copySuccess'),
                position: 'middle',
            })
        });
        clipboard.on("error", (e) => {
            console.log("浏览器不支持复制");
            // 释放内存
            clipboard.destroy();
        });
    } else {

    }
};

/**
 * 检查是否禁言
 */
const lookGroup = async () => {
    if (!IMUtils.isGroup(chatkey)) {
        return;
    }

    isforbidchat.value = false;
    let group = await getImGroupItem(chatkey);
    if (group) {
        console.log('group', group);
        groupMemberCount.value = group.member_cnt;
        // 管理员列表
        let adminUids = [group.grouphost];
        for (let i in group.admins) {
            adminUids.push(group.admins[i].adminuid);
        }
        adminUidList.value = adminUids;

        // 禁言白名单列表
        let whiteUids = [];
        if (group.white_uids && group.white_uids != "") {
            const arr = group.white_uids.split(",");
            for (let i in arr) {
                if (arr[i] && arr[i] != "") {
                    whiteUids.push(Number(arr[i]));
                }
            }
            whiteUidList.value = whiteUids;
        }

        let nowtime = IMUtils.getHm();
        if (group.isforbid == 1 && (nowtime > group.forbidbegintm && nowtime < group.forbidendtm)) {
            isforbidchat.value = true;
        } else {
            isforbidchat.value = false;
        }
        if (group.grouphost == user.value.uid) {
            // 群主不禁言
            isforbidchat.value = false;
        } else {
            for (let i in group.admins) {
                if (group.admins[i].adminuid == user.value.uid) {
                    // 管理员不禁言
                    isforbidchat.value = false;
                }
            }
        }
    }
    if (isforbidchat.value) {
        console.log("groupdataall", group);
        let forbidbegintm = IMUtils.intToTime(group.forbidbegintm);
        let forbidendtm = IMUtils.intToTime(group.forbidendtm);
        forbidtime.value = t('tips.forbid') + forbidbegintm + "-" + forbidendtm;
    }
}

const scrollToBottom = () => {
    const containers = document.getElementsByClassName("msgItemBox");
    if (containers && containers.length > 0) {
        const el = containers[containers.length - 1];
        if (el) {
            el.scrollIntoView();
        }
    }
}

const onNoticeClose = (group: any) => {
    if (group) {
        msg_read_group_notify(group.groupkey, group.notifyversion);
        showNotice.value = false;
        showNoticeGroup.value = {};
    }
}

const checkIsAdmin = (item: any) => {
    if (!item || !item.uid) {
        return 0;
    }
    if (adminUidList.value && adminUidList.value.indexOf(item.uid) >= 0) {
        // 管理员返回1
        return 1;
    }
    if (whiteUidList.value && whiteUidList.value.indexOf(item.uid) >= 0) {
        // 禁言白名单返回2
        return 2;
    }
    return 0;
}


const __returned__ = { zbimg, adminimg, copy_id, t, th, bqSwpierList, router, route, userStore, user, toLogin, name, list, id, chatkey, isGroup, groupMemberCount, showAddRes, inputValue, fileList, showShare, arterBg, arterBtn, offArterBtn, nowScrollHeight, page, loading, noMoreData, isforbidchat, forbidtime, showNotice, showNoticeGroup, adminUidList, whiteUidList, chatmsgno_list, onRefresh, clientHeight, refrenceCon, hasInit, standalone, normalizeUid, getCurrentUid, isSelfMessage, autoAssistanceClientKeyPrefix, getChatTargetUid, props, showFaqPanel, faqView, activeFaq, remoteFaqList, faqQuickScrollRef, normalizeAiReplyItem, loadFaqList, faqItems, hasFaq, msgListBottomSpace, faqQuickItems, getFaqHtml, openFaqList, openFaqDetail, closeFaqPanel, emits, onDbread, initChatkey, goUpdateIMList, isNewMsg, Toscroll, onClickLeft, scrollHandle, unique, isAutoAssistanceMessage, getAutoMsgList, getMsgList, headurl, groupBgc, createAvarar, getChatInfo, preSqldata, upaddataall, addImg, addVideo, addFile, addRes, onOversize, sendMsg, getmsgurl, openBiaoqing, selBq, getJsonImage, getJsonImageWid, onImagePreview, scrollDisabled, timeout, debounce, changeInputType, downloadshow, showDownApp, open, checkname, keyup_submit, atemsg, msgurl, dataimgurl, tapFile, audioclick, ended, tryParse, refplay, options, showMenu, optionTap, showRefrence, toRefrence, hideMenu, copyclass, lookGroup, scrollToBottom, onNoticeClose, checkIsAdmin, ChatUtils, TextEllipsis, IMformatDate, filedatasize, checked_sel, checked, biaoqing, add_res, faqClose, faqBack }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})